import { render, staticRenderFns } from "./driver-info.vue?vue&type=template&id=67fadd30&scoped=true"
import script from "./driver-info.vue?vue&type=script&lang=js"
export * from "./driver-info.vue?vue&type=script&lang=js"
import style0 from "./driver-info.vue?vue&type=style&index=0&id=67fadd30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fadd30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fadd30')) {
      api.createRecord('67fadd30', component.options)
    } else {
      api.reload('67fadd30', component.options)
    }
    module.hot.accept("./driver-info.vue?vue&type=template&id=67fadd30&scoped=true", function () {
      api.rerender('67fadd30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-analysis/driver-data/normal/components/driver-info.vue"
export default component.exports